import { all, fork } from '@redux-saga/core/effects';
import { watchGetCustomerList } from './customerListSaga';
import { watchSaveNewCustomer } from './saveNewCustomerSaga';
import { watchStartNewOrder } from './startNewOrderSaga';
import { watchGetAvailableItems } from './getAvailableItemsSaga';
import { watchSendLineItems } from './sendLineItemsSaga';
import { watchUpdateOrder } from './updateOrderSaga';
import { watchGetOrder } from './getOrderSaga';
import { watchLogin } from './loginSaga';
import { watchLogout } from './logoutSaga';
import { watchCreateNewUser } from './createNewUserSaga';
import { watchSendTextMessage } from './sendTextMessageSaga';
import { watchSaveUpdateCustomer } from './saveUpdateCustomerSaga';
import { watchSaveEsrog } from './saveEsrogSaga';
import { watchSaveAravot } from './saveAravotSaga';
import { watchSaveLulav } from './saveLulavSaga';
import { watchSaveExtra } from './saveExtraSaga';
import { watchSaveGrades } from './saveGradesSaga';
import { watchSaveHadasim } from './saveHadasimSaga';

export default function* rootSaga(): any {
  yield all([
    fork(watchGetCustomerList),
    fork(watchSaveNewCustomer),
    fork(watchSaveUpdateCustomer),
    fork(watchStartNewOrder),
    fork(watchGetAvailableItems),
    fork(watchSendLineItems),
    fork(watchUpdateOrder),
    fork(watchGetOrder),
    fork(watchLogin),
    fork(watchLogout),
    fork(watchCreateNewUser),
    fork(watchSendTextMessage),
    fork(watchSaveEsrog),
    fork(watchSaveAravot),
    fork(watchSaveLulav),
    fork(watchSaveExtra),
    fork(watchSaveGrades),
    fork(watchSaveHadasim),
  ]);
}
